<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label for="">Cantidad</label>
                        <input type="number" class="form-control" v-model="PaquetePropiedad.Cantidad">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="errorvalidacion.Cantidad" :Mensaje="errorvalidacion.Cantidad[0]"></Cvalidation></label>
                    </div>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
export default {
    name:'Form',
    props:['poBtnSave'],
    data() {
        return {
            Modal:true,
            Name:'PropiedadMonitoreoInternoForm',
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            PaquetePropiedad:{
                IdPaquetePropiedad:0,
                Cantidad:0
            },
            errorvalidacion:[]
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.disableBtn=true;
            let formData=new FormData();
            formData.set('IdPaquetePropiedad',this.PaquetePropiedad.IdPaquetePropiedad);
            formData.set('Cantidad',this.PaquetePropiedad.Cantidad);
            await this.$http.post('paquetepropiedad/post',formData
            ).then((res)=>{
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#ModalForm').modal('hide');
                this.bus.$emit('List');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            })
        },
        Limpiar(){
            this.PaquetePropiedad={
                IdPaquetePropiedad:0,
                Cantidad:0
            },
            this.errorvalidacion=[];
        },
        get_one(){
            this.$http.get('paquetepropiedad/recovery',{
                params:{
                    IdPaquetePropiedad:this.PaquetePropiedad.IdPaquetePropiedad
                }
            }).then((res)=>{
                this.PaquetePropiedad.IdPaquetePropiedad=res.data.data.PaquetePropiedad.IdPaquetePropiedad;
                this.PaquetePropiedad.Cantidad=res.data.data.PaquetePropiedad.Cantidad;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        }
    },
    created() {
        this.bus.$off('Nuevo');
        this.bus.$on('Nuevo',(data,Id)=> 
        {
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=false; 
            this.bus.$off('Save');

            this.bus.$on('Save',()=>
            {
                this.Guardar();
            });

            this.Limpiar();
            if (Id>0) 
            {
                this.PaquetePropiedad.IdPaquetePropiedad=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
        });
        if (this.Id!=undefined)
        {
            this.PaquetePropiedad.IdPaquetePropiedad=this.Id;
            this.get_one();
        }
    }
}
</script>

<style>

</style>